// eslint-disable-next-line @atlaskit/design-system/use-spotlight-package
import Spotlight from '@atlaskit/onboarding/spotlight';

import { token } from '@atlaskit/tokens';

import { useIntl } from 'react-intl';

import { messages } from './messages';

import { type JSX } from 'react/jsx-runtime';

export const FilterSpotlight = ({
	onNext,
	onDismiss,
}: {
	onNext: () => void;
	onDismiss: (isTourCompleted?: boolean) => void;
}): JSX.Element => {
	const { formatMessage } = useIntl();

	return (
		<Spotlight
			actions={[
				{
					onClick: onNext,
					text: formatMessage(messages.nextButton),
				},
				{
					// eslint-disable-next-line @post-office/message-linting/require-instrumented-interactions -- HighImpactOnboarding.dismissMessage records onClosed through the onDismiss callback.
					onClick: () => onDismiss(),
					text: formatMessage(messages.dismissButton),
					appearance: 'subtle',
				},
			]}
			target="jql-builder.ui.jql-builder.editor"
			key="jql-builder.ui.jql-builder.editor"
			targetRadius={token('radius.medium', '3px')}
			dialogWidth={285}
			targetBgColor={token('elevation.surface')}
			actionsBeforeElement={<>1/2</>}
			testId="filter-spotlight"
		>
			{formatMessage(messages.filterSpotlightMessage)}
		</Spotlight>
	);
};
